import { render, staticRenderFns } from "./GroupsEditModal.vue?vue&type=template&id=9bd1fda4"
import script from "./GroupsEditModal.vue?vue&type=script&lang=js"
export * from "./GroupsEditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports